module.exports = __webpack_public_path__ + "static/media/product.ff1ca983.png";